export default __webpack_public_path__ + "static/media/guide28.40af2ea7.png";